
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuKitoMuzutoTsuchitoWoodTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/kito_mizuto_tsuchito",
  title: "【新食感】表参道「木と水と土と」で自然派パンケーキを食べよう！",
  description: "表参道の人気パンケーキ店「木と水と土と」のコンセプトや特徴的な記事についてご紹介します！関東では原宿・表参道にしか店舗がない「木と水と土と」は、大人気の新食感生地の「クリームブリュレパンケーキ」をはじめとして、いろんな食感の生地が楽しめるお店。自然を大事にしたコンセプトや店内の内装も併せてご紹介させていただきます！",
  topImg: harajukuKitoMuzutoTsuchitoWoodTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "デート", "女子会", "スイーツ", "インスタ映え", "パンケーキ", "穴場"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`表参道の人気パンケーキ店「木と水と土と」は関西発祥のお店で、関東では原宿・表参道にしか店舗がありません。`}</p>
    <p>{`大人気の新食感生地「ブリュレパンケーキ」をはじめとして、いろんな食感の生地が楽しめる新感覚のパンケーキを揃えています！`}</p>
    <p>{`自然を大事にしたコンセプトで作るこだわりのある店内、夏限定のインパクトのあるスイーツなど、原宿・表参道でパンケーキを食べるなら一度は訪れてみたいパンケーキ店「木と水と土と」をご紹介します！`}</p>
    <hr></hr>
    <h2>{`「木と水と土と」とは？`}</h2>
    <InstaImage postId="B-YaVkEgP02" mdxType="InstaImage" />
    <h3>{`「木と水と土と」は和歌山発祥のお店`}</h3>
    <p>{`一度聞いたら忘れない独特な名前「木と水と土と」。
和歌山発祥のお店で、和歌山の自然をモチーフにして作られたお店なんだそうで、一号店は白浜にあります。`}</p>
    <h3>{`関東は１店舗のみ`}</h3>
    <p>{`関東だと原宿・表参道エリアの１店舗しか構えていないので、関東で「木と水と土と」のパンケーキが食べたい場合は、原宿・表参道に行きましょう！`}</p>
    <InstaImage postId="B_HV5WHFOZj" mdxType="InstaImage" />
    <h3>{`グルテンフリーのパンケーキが食べられる！？`}</h3>
    <p>{`和歌山特産の食品を使用し、米粉を使ったグルテンフリーのパンケーキが食べられることで有名！
そんな噂を聞きつけて、海外の観光客や女性客の多くの方が訪れているお店なんです！`}</p>
    <hr></hr>
    <h2>{`自然をモチーフにした店内`}</h2>
    <p>{`「木と水と土と」という名前からイメージできるように、自然を感じられるこだわりのある内装が店内には施されています！
表参道の都会的な雰囲気を取り入れつつ、自然を感じられる独特な雰囲気。`}</p>
    <h3>{`土をイメージした壁`}</h3>
    <p>{`入口には粘土を使ったような大きなグレーの壁に、「木と水と土と」とお店の名前が刻まれています。
電球との相性があっていて、全体的に迫力がある壁。`}</p>
    <InstaImage postId="B-OHAnZAnAs" mdxType="InstaImage" />
    <h3>{`木をイメージした店内`}</h3>
    <p>{`飲食スペースは木で統一されていて天井が高く、植物も木の雰囲気と合う穏やかな空間になっています！`}</p>
    <InstaImage postId="Bt7ghVUgzgS" mdxType="InstaImage" />
    <h3>{`木を基調としたシックで落ち着いた雰囲気ですよね！`}</h3>
    <InstaImage postId="B8IL_Wvg_Fk" mdxType="InstaImage" />
    <h3>{`店内をブルーで水をイメージ！`}</h3>
    <p>{`こんなおしゃれな席も...！カップルで行ってみたい！`}</p>
    <InstaImage postId="B4gY50-AjnK" mdxType="InstaImage" />
    <h4>{`席に座るとこんな感じに写ります！`}</h4>
    <InstaImage postId="BvoCJYugdfZ" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`「木と水と土と」の新食感の生地`}</h2>
    <p>{`「木と水と土と」の魅力は、その生地のパターン。`}</p>
    <p>{`パンケーキといえばふわっとしたパンケーキのイメージが強いですが、
「木と水と土と」では、ふわっとした食感に加えて、他の 3 つの食感を楽しめます！`}</p>
    <h3>{`【カリッとした】クリームブリュレパンケーキ (1,000 円)`}</h3>
    <InstaImage postId="B-3cFLLF3MD" mdxType="InstaImage" />
    <p>{`「木と水と土と」で 1 番の人気のメニューが、このクリームブリュレパンケーキ。
見た目よりも実際はボリューム感があり、パリッとした新食感の生地です！
表面はキャラメルリゼのコーティングによってカリッと、食べたあとにはフワッとしたパンケーキ生地の食感に、たっぷりのカスタードクリームが流れ込んできます。`}</p>
    <p>{`インスタ映えも間違いなしの一品です！`}</p>
    <h3>{`【サクッとした】キャラメルミルフィーユパンケーキ(1,030 円)`}</h3>
    <InstaImage postId="BjACFR7FqXk" mdxType="InstaImage" />
    <p>{`こちらも人気メニューの一つ`}<strong parentName="p">{`ミルクティーブリュレパンケーキ`}</strong>{`。
２枚のパンケーキをパイ生地でサンドしたミルフィーユ風パンケーキで、サクサクのパイの香ばしさとキャラメルクリームの香りが口の中でふわっと広がる一品！
フルーツが食感とクリームの甘さを引き立ててくれます！`}</p>
    <h3>{`【モチッとした】米粉パンケーキ`}</h3>
    <InstaImage postId="B-BKeLig77K" mdxType="InstaImage" />
    <p>{`グルテンフリーの米粉で作るパンケーキで、アレルギーの方でも食べやすい一品となっています！
外国人の観光客や女性に人気のメニューで、もちっとした食感も楽しめます。`}</p>
    <h3>{`夏の時期はこんなメニューも！`}</h3>
    <p><strong parentName="p">{`しろくまのかき氷`}</strong></p>
    <InstaImage postId="B1Q03q-lRoo" mdxType="InstaImage" />
    <p>{`インパクトのあるかき氷で、これが出てきたら写真を撮らずにはいられないメニュー！
「木と水と土と」では、こういった楽しめるメニューがたくさんあります！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`「木と水と土と」は表参道駅の B2 出口から徒歩１分という好立地にありアクセス抜群です！
山手線の原宿駅からも徒歩圏内の距離にあるので、どちらからもアクセスが可能となっています！`}</p>
    <GoogleMap lat={35.664187} lng={139.7083423} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`「木と水と土と」の特徴や、新食感のパンケーキについてお伝えしてきましたが、いかがでしたでしょうか？
いつもとちょっと違ったパンケーキが食べたい！という時には、原宿・表参道で普段とは違う食感が楽しめる「木と水と土と」を選択肢の一つとして、考えてみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;